import { render, staticRenderFns } from "./crossTable.vue?vue&type=template&id=06a59936&scoped=true"
import script from "./crossTable.vue?vue&type=script&lang=js"
export * from "./crossTable.vue?vue&type=script&lang=js"
import style0 from "./crossTable.vue?vue&type=style&index=0&id=06a59936&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a59936",
  null
  
)

export default component.exports